import type { Bet } from '../../../../schema/coupon/entry.js';

/**
 * Selects the system size based on raw outcome groups (without board context).
 * Used when calculating system size for outcome data that doesn't yet have a complete Board structure.
 *
 * System size is computed as the product of outcome counts per event (summed across all rows).
 * For each event, we sum all outcomes from all rows, then multiply between events.
 *
 * @param outcomes Outcome groups
 * @returns The system size for the given outcomes
 */
export function selectSystemSizeFromOutcomes(outcomes: Bet): number {
  return outcomes.reduce((product, eventOutcomes) => {
    // Sum outcomes across all rows for this event
    const eventOutcomeCount = eventOutcomes.reduce((sum, row) => sum + (row.length || 0), 0) || 1;
    return product * eventOutcomeCount;
  }, 1);
}
